export const setShowResultModal = (modalStatus) => {
    return {
        type: "SET_SHOW_RESULT_MODAL",
        payload: modalStatus
    };
};

export const setShowAuctionSubmitModal = (modalStatus) => {
    return {
        type: "SET_SHOW_AUCTION_SUBMIT_MODAL",
        payload: modalStatus
    };
};

export const setShowBuyTurnModal = (modalStatus) => {
    return {
        type: "SET_SHOW_BUY_TURN_MODAL",
        payload: modalStatus
    };
};

export const setShowConfirmModal = (modalStatus) => {
    return {
        type: "SET_SHOW_CONFIRM_MODAL",
        payload: modalStatus
    };
};

export const setDataToModal = (modalData) => {
    return {
        type: "SET_DATA_TO_MODAL",
        payload: modalData
    };
};

export const setDataFromModal = (modalData) => {
    return {
        type: "SET_DATA_FROM_MODAL",
        payload: modalData
    };
};